import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './Notification.scss';
import { useEffect } from 'react';

export default function Notification({ showsetNotification, showNotificationType }) {
    const location = useLocation()
    useEffect(() => {
        const timer = setTimeout(() => {
            showsetNotification(false)
        }, 2900);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="Notification">
            {showNotificationType == "signup" ?
                <div className="NotificationMenu">
                    <img src={require(`../../Images/n-success.png`)} />
                    <span>
                        <h1>Signup Successful</h1>
                        <p>Welcome to HandyBy—start your first project anytime.</p>
                    </span>
                </div>
                : showNotificationType == "login" ?
                    <div className="NotificationMenu">
                        <img src={require(`../../Images/n-success.png`)} />
                        <span>
                            <h1>Welcome Back!</h1>
                            <p>You're all set—start browsing or create a new project.</p>
                        </span>
                    </div>
                    : showNotificationType == "logout" ?
                        <div className="NotificationMenu" style={{"backgroundColor":"#ecf4ff","border":"1px solid #5797ff"}}>
                            <img src={require(`../../Images/n-info.png`)} />
                            <span>
                                <h1>See You Soon!</h1>
                                <p>You’ve successfully logged out. Come back anytime.</p>
                            </span>
                        </div>
                        : showNotificationType == "emailsent" ?
                            <div className="NotificationMenu">
                                <img src={require(`../../Images/n-success.png`)} />
                                <span>
                                    <h1>Email on the Way!</h1>
                                    <p>You’ll receive it shortly—don’t forget to check spam too.</p>
                                </span>
                            </div>
                            :

                            null}

        </div>
    )
}
